import { render, staticRenderFns } from "./ActionsDropdown.vue?vue&type=template&id=4b0bb932&scoped=true&"
import script from "./ActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./ActionsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ActionsDropdown.vue?vue&type=style&index=0&id=4b0bb932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0bb932",
  null
  
)

export default component.exports